// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site Monitoring — compact, fixed-height layout */

.sm-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 520px;
  max-height: calc(100vh - 88px);
}

.sm-stats {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  flex-shrink: 0;
}

.sm-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  text-align: center;
}

.sm-stat--healthy { border-bottom: 2px solid #22c55e; }
.sm-stat--degraded { border-bottom: 2px solid #eab308; }
.sm-stat--critical { border-bottom: 2px solid #ef4444; }
.sm-stat--offline { border-bottom: 2px solid #94a3b8; }

.sm-stat-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
}

.sm-stat-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 2px;
}

.sm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.sm-select {
  padding: 7px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
  color: #334155;
  min-width: 150px;
}

.sm-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
  flex: 1 1;
  min-width: 120px;
}

.sm-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.sm-auto-refresh {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  color: #64748b;
}

.sm-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.sm-btn:hover { background: #f8fafc; }

.sm-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.sm-btn--primary:hover { background: #1d4ed8; }

.sm-insights-wrap {
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
}

.sm-main {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
}

.sm-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sm-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
  flex-shrink: 0;
}

.sm-panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
}

.sm-panel-sub {
  font-size: 13px;
  color: #94a3b8;
}

.sm-panel-body {
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.sm-org {
  border-bottom: 1px solid #f8fafc;
}

.sm-org-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-size: 15px;
  color: #64748b;
}

.sm-org-head:hover { background: #f8fafc; }

.sm-org-name {
  font-weight: 600;
  color: #0f172a;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sm-org-meta {
  font-size: 13px;
  color: #94a3b8;
  flex-shrink: 0;
}

.sm-sites {
  background: #fafbfc;
  border-top: 1px solid #f1f5f9;
}

.sm-site {
  width: 100%;
  display: grid;
  grid-template-columns: 28px 1fr auto;
  gap: 8px;
  align-items: center;
  padding: 8px 12px 8px 28px;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-size: 15px;
}

.sm-site:hover { background: #f1f5f9; }

.sm-site--active {
  background: #eff6ff;
  border-left: 3px solid #2563eb;
  padding-left: 25px;
}

.sm-site-name {
  font-weight: 500;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sm-site-time {
  font-size: 13px;
  color: #94a3b8;
  white-space: nowrap;
}

.sm-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  flex-shrink: 0;
}

.sm-status--healthy, .sm-status--up { background: #dcfce7; color: #166534; }
.sm-status--degraded { background: #fef9c3; color: #854d0e; }
.sm-status--critical, .sm-status--down { background: #fee2e2; color: #991b1b; }
.sm-status--offline, .sm-status--unknown { background: #f1f5f9; color: #475569; }

.sm-detail-head {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.sm-detail-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.sm-detail-sub {
  font-size: 15px;
  color: #64748b;
  margin: 2px 0 8px;
}

.sm-detail-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.sm-detail-meta {
  font-size: 13px;
  color: #94a3b8;
}

.sm-detail-body {
  padding: 12px 14px;
}

.sm-checks-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 8px;
}

.sm-checks {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}

.sm-check {
  padding: 8px 10px;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 15px;
}

.sm-check-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.sm-check-time {
  font-size: 14px;
  color: #94a3b8;
  margin-top: 3px;
}

.sm-offline-cams {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 8px 10px;
  background: #fffbeb;
  border-radius: 6px;
  font-size: 15px;
  color: #92400e;
}

.sm-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #94a3b8;
  font-size: 15px;
  gap: 8px;
  padding: 24px;
}

.sm-events {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  max-height: 180px;
}

.sm-events-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.sm-events-body {
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.sm-events-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.sm-events-table thead th {
  position: sticky;
  top: 0;
  background: #fafbfc;
  padding: 6px 12px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #f1f5f9;
}

.sm-events-table thead th:nth-child(1) { width: 110px; }
.sm-events-table thead th:nth-child(2) { width: 26%; }

.sm-events-table td {
  padding: 7px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: top;
}

.sm-event--critical { background: #fef2f2; }
.sm-event--warning { background: #fffbeb; }

.sm-event-time {
  color: #64748b;
  font-size: 13px;
  white-space: nowrap;
}

.sm-event-org {
  display: block;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sm-event-email {
  display: block;
  font-size: 14px;
  color: #94a3b8;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sm-event-msg {
  color: #475569;
  line-height: 1.35;
  word-break: break-word;
}

.sm-empty {
  padding: 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.sm-spin {
  animation: sm-spin 0.8s linear infinite;
}

@keyframes sm-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 960px) {
  .sm-page {
    height: auto;
    max-height: none;
  }

  .sm-main {
    grid-template-columns: 1fr;
  }

  .sm-stats {
    grid-template-columns: repeat(3, 1fr);
  }

  .sm-panel-body {
    max-height: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteMonitoringPage.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB,gCAAgC,EAAE;AACtD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,oBAAoB,gCAAgC,EAAE;;AAEtD;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,yCAAyC,mBAAmB,EAAE,cAAc,EAAE;AAC9E,2CAA2C,mBAAmB,EAAE,cAAc,EAAE;;AAEhF;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,cAAc;EACd,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,yCAAyC,YAAY,EAAE;AACvD,yCAAyC,UAAU,EAAE;;AAErD;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Site Monitoring — compact, fixed-height layout */\n\n.sm-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 520px;\n  max-height: calc(100vh - 88px);\n}\n\n.sm-stats {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.sm-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  text-align: center;\n}\n\n.sm-stat--healthy { border-bottom: 2px solid #22c55e; }\n.sm-stat--degraded { border-bottom: 2px solid #eab308; }\n.sm-stat--critical { border-bottom: 2px solid #ef4444; }\n.sm-stat--offline { border-bottom: 2px solid #94a3b8; }\n\n.sm-stat-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.1;\n}\n\n.sm-stat-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-top: 2px;\n}\n\n.sm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.sm-select {\n  padding: 7px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n  color: #334155;\n  min-width: 150px;\n}\n\n.sm-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n  flex: 1;\n  min-width: 120px;\n}\n\n.sm-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.sm-auto-refresh {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.sm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.sm-btn:hover { background: #f8fafc; }\n\n.sm-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.sm-btn--primary:hover { background: #1d4ed8; }\n\n.sm-insights-wrap {\n  flex-shrink: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.sm-main {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n}\n\n.sm-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sm-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n  flex-shrink: 0;\n}\n\n.sm-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin: 0;\n}\n\n.sm-panel-sub {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.sm-panel-body {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.sm-org {\n  border-bottom: 1px solid #f8fafc;\n}\n\n.sm-org-head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.sm-org-head:hover { background: #f8fafc; }\n\n.sm-org-name {\n  font-weight: 600;\n  color: #0f172a;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sm-org-meta {\n  font-size: 13px;\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.sm-sites {\n  background: #fafbfc;\n  border-top: 1px solid #f1f5f9;\n}\n\n.sm-site {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 28px 1fr auto;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 12px 8px 28px;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-size: 15px;\n}\n\n.sm-site:hover { background: #f1f5f9; }\n\n.sm-site--active {\n  background: #eff6ff;\n  border-left: 3px solid #2563eb;\n  padding-left: 25px;\n}\n\n.sm-site-name {\n  font-weight: 500;\n  color: #334155;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sm-site-time {\n  font-size: 13px;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.sm-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n  flex-shrink: 0;\n}\n\n.sm-status--healthy, .sm-status--up { background: #dcfce7; color: #166534; }\n.sm-status--degraded { background: #fef9c3; color: #854d0e; }\n.sm-status--critical, .sm-status--down { background: #fee2e2; color: #991b1b; }\n.sm-status--offline, .sm-status--unknown { background: #f1f5f9; color: #475569; }\n\n.sm-detail-head {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.sm-detail-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.sm-detail-sub {\n  font-size: 15px;\n  color: #64748b;\n  margin: 2px 0 8px;\n}\n\n.sm-detail-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.sm-detail-meta {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.sm-detail-body {\n  padding: 12px 14px;\n}\n\n.sm-checks-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin: 0 0 8px;\n}\n\n.sm-checks {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 6px;\n}\n\n.sm-check {\n  padding: 8px 10px;\n  background: #f8fafc;\n  border-radius: 6px;\n  font-size: 15px;\n}\n\n.sm-check-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.sm-check-time {\n  font-size: 14px;\n  color: #94a3b8;\n  margin-top: 3px;\n}\n\n.sm-offline-cams {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  background: #fffbeb;\n  border-radius: 6px;\n  font-size: 15px;\n  color: #92400e;\n}\n\n.sm-detail-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  color: #94a3b8;\n  font-size: 15px;\n  gap: 8px;\n  padding: 24px;\n}\n\n.sm-events {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  max-height: 180px;\n}\n\n.sm-events-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n}\n\n.sm-events-body {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.sm-events-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.sm-events-table thead th {\n  position: sticky;\n  top: 0;\n  background: #fafbfc;\n  padding: 6px 12px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.sm-events-table thead th:nth-child(1) { width: 110px; }\n.sm-events-table thead th:nth-child(2) { width: 26%; }\n\n.sm-events-table td {\n  padding: 7px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: top;\n}\n\n.sm-event--critical { background: #fef2f2; }\n.sm-event--warning { background: #fffbeb; }\n\n.sm-event-time {\n  color: #64748b;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.sm-event-org {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sm-event-email {\n  display: block;\n  font-size: 14px;\n  color: #94a3b8;\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sm-event-msg {\n  color: #475569;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.sm-empty {\n  padding: 24px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.sm-spin {\n  animation: sm-spin 0.8s linear infinite;\n}\n\n@keyframes sm-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 960px) {\n  .sm-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .sm-main {\n    grid-template-columns: 1fr;\n  }\n\n  .sm-stats {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .sm-panel-body {\n    max-height: 280px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
